export default __webpack_public_path__ + "static/media/postgresql.5c366621.svg";